export const HR_ROUTES = {
  EMPLOYEES: '/hr/employees',
  REFERENCE_DATA: '/hr/reference-data',
};
